import React, { useEffect, useState } from "react";
import axios from "../../Utils/Axios";
import LoadingOverlay from "react-loading-overlay-ts";
import RingLoader from "react-spinners/RingLoader";
import { useAlert } from "react-alert";
import { ErrorHandler } from "../../ui/ErrorHandler";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Typography } from "@mui/material";
import EditTag from "./EditTag";
import './Tag.css'


function Tag({ page, pageId }) {
  const alert = useAlert();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState('');
  const [link, setLink] = useState('');
  const [tags, setTags] = useState([]);

  useEffect(() => {
    getTag();
  }, [pageId]);

  const getTag = () => {
    let formData = new FormData();
    formData.append("page", page);
    formData.append("page_id", pageId);
    axios(`admin/tags`, {
      method: "POST",
      data: formData,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + JSON.parse(localStorage.getItem("data")),
      },
    })
      .then((response) => {
        if (response.status === 200) {
          setTags(response.data.data);
        } else {
          setLoading(false);
          ErrorHandler(alert, response.status, response.data.message)
        }
      })
      .catch(({ response }) => {
        setLoading(false);
        ErrorHandler(alert, response.status, response.data.message)
      });
  };

  const tagAdd = (event) => {
    event.preventDefault();
    setLoading(true);
    let formData = new FormData();
    formData.append("title", title);
    formData.append("link", link);
    formData.append("page", page);
    formData.append("page_id", pageId);
    axios("admin/tag_save", {
      method: "POST",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + JSON.parse(localStorage.getItem("data")),
      },
    })
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          setLoading(false);
          ErrorHandler(alert, response.status, response.data.message);
          setLink('');
          setTitle('');
          getTag();
        } else {
          setLoading(false);
          ErrorHandler(alert, response.status, response.data.message)
        }
      })
      .catch(({ response }) => {
        setLoading(false);
        ErrorHandler(alert, response.status, response.data.message)
      });
  };

  const tagUpdate = (tag) => {
    setLoading(true);
    let formData = new FormData();
    formData.append("title", tag.title);
    formData.append("link", tag.link);
    formData.append("id", tag.id);

    axios("admin/tag_update", {
      method: "POST",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + JSON.parse(localStorage.getItem("data")),
      },
    })
      .then((response) => {
        if (response.status === 200) {
          setLoading(false);
          ErrorHandler(alert, response.status, response.data.message);
          setLink('');
          setTitle('');
          getTag();
        } else {
          setLoading(false);
          ErrorHandler(alert, response.status, response.data.message)
        }
      })
      .catch(({ response }) => {
        setLoading(false);
        ErrorHandler(alert, response.status, response.data.message)
      });
  };

  const tagDelete = (id) => {
    setLoading(true);
    let formData = new FormData();
    formData.append("id", id);

    axios("admin/tag_delete", {
      method: "POST",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + JSON.parse(localStorage.getItem("data")),
      },
    })
      .then((response) => {
        if (response.status === 200) {
          setLoading(false);
          ErrorHandler(alert, response.status, response.data.message);
          setLink('');
          setTitle('');
          getTag();
        } else {
          setLoading(false);
          ErrorHandler(alert, response.status, response.data.message)
        }
      })
      .catch(({ response }) => {
        setLoading(false);
        ErrorHandler(alert, response.status, response.data.message)
      });
  };


  return (
    <LoadingOverlay
      active={loading}
      styles={{
        overlay: (base) => ({
          ...base,
          background: "rgba(255, 255, 255, 0.9)",
        }),
        spinner: (base) => ({
          ...base,
          width: "75px",
          "& svg circle": {
            stroke: "rgba(0, 0, 0, 0.8)",
          },
        }),
      }}
      spinner={<RingLoader loading={loading} color="#36d7b7" />}
      text="..."
    >
      <div className="row bg-smoke">
        <h3 className="pb-2">TAG Section</h3>
        <div className="col-md-12  FAQ">
          <div className="row align-items-center p-3">
            <div class="col-md-5 form-group mb-0">
              <textarea placeholder="Enter Title" id="exampleInputTitle" class="form-control" onChange={(e) => setTitle(e.target.value)} value={title}></textarea>
            </div>
            <div class="col-md-5 form-group mb-0">
              <textarea placeholder="Enter Link   example:https://example.com" id="exampleInputLink" class="form-control" onChange={(e) => setLink(e.target.value)} value={link}></textarea>
            </div>
            <button type="button" onClick={tagAdd} class=" col-md-2 btn btn-primary">Add Tag</button>
          </div>
        </div>
        <div className="col-md-12">
          {tags.length > 0 ? tags.map((value, index) => {
            return (
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Box p={1} color="primary" >
                    <Typography
                      variant="h6"
                      color="primary"
                      gutterBottom
                    >
                      {value.title}

                    </Typography>
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  <EditTag tag={value} tagUpdate={tagUpdate} tagDelete={tagDelete}></EditTag>
                </AccordionDetails>
              </Accordion>
            )
          }) : ''}
        </div>
      </div>
    </LoadingOverlay>
  )
}

export default Tag